import React, { FC, useContext } from 'react';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import NolNoticeBottomSheet from '../NolNoticeBottomSheet';

interface PointBottomSheetProps {}

const PointBottomSheet: FC<PointBottomSheetProps> = () => {
  const store = useContext(NolPromotionStoreCtx);
  const messages = [
    '전월 이용 금액 40만원(본인+가족 카드) 미만 시 적립 제외',
    '모든 가맹점은 현대카드 가맹점 등록 및 업종 분류 기준',
    '상세 내용은 페이지 하단의 유의사항 참조',
    'NOL · NOL 인터파크(NOL 인터파크투어/NOL 티켓)· 트리플에서 이스타항공, 에어서울 국내선 항공권 결제건은 NOL 포인트 적립되지 않음',
  ].filter(Boolean);

  return (
    <NolNoticeBottomSheet
      title={'포인트 유의사항'}
      isOpen={store.isPointBottomSheetOpen}
      onRequestClose={() => (store.isPointBottomSheetOpen = false)}
    >
      <ul>
        {messages.map((line, key) => (
          <li key={key}>{line}</li>
        ))}
      </ul>
    </NolNoticeBottomSheet>
  );
};

export default observer(PointBottomSheet);
